module.exports = __webpack_public_path__ + "static/media/environment-cta.b8c8a599.jpg";